import React, { memo, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { InputWrapper, StyledInput } from './styledInput';

const Input = forwardRef(({
  text = '',
  handleChange,
  className = '',
  placeholder = 'Title',
  onEnter,
}, ref) => {
  const handleKeyDown = (event) => {
    if (onEnter) {
      if (event.key === 'Enter') {
        event.preventDefault();
        onEnter();
      }
    }
  };
  return (
    <InputWrapper className={className}>
      <StyledInput
        ref={ref}
        value={text}
        onChange={handleChange}
        placeholder={placeholder}
        onKeyDown={handleKeyDown}
      />
    </InputWrapper>
  );
});

Input.propTypes = {
  className: PropTypes.string,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  handleChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  onEnter: PropTypes.func,
};

export default memo(Input);
